import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import configureReducer from './reducer'
import configureMiddleware from './middleware'

type Options = {
  initialState: Object,
  platformDeps?: Object,
  platformMiddleware?: Array<Function>,
}

const configureStore = (options: Options) => {
  const {
    initialState,
    platformDeps = {},
    platformMiddleware = [],
  } = options

  const reducer = configureReducer(initialState)

  let middleware = configureMiddleware(
    initialState,
    platformDeps,
    platformMiddleware,
  )

  if (process.env.IS_BROWSER) {
    middleware = composeWithDevTools(applyMiddleware(...middleware))
  } else {
    middleware = applyMiddleware(...middleware)
  }

  const store = createStore(
    reducer,
    initialState,
    middleware,
  )

  // Enable hot reloading for reducers.
  if (module.hot && typeof module.hot.accept === 'function') {
    if (initialState.device.isReactNative) {
      // React Native for some reason needs accept without the explicit path.
      // facebook.github.io/react-native/blog/2016/03/24/introducing-hot-reloading.html
      module.hot.accept(() => {
        const configureReducer = require('./reducer').default
        store.replaceReducer(configureReducer(initialState))
      })
    } else {
      // Webpack for some reason needs accept with the explicit path.
      module.hot.accept('./reducer', () => {
        const configureReducer = require('./reducer').default
        store.replaceReducer(configureReducer(initialState))
      })
    }
  }

  return store
}

export default configureStore



// WEBPACK FOOTER //
// ./src/common/configure/store.js